import { Button, Dialog, DialogActions, DialogContent, DialogTitle
    , Grid, TextField, Typography, Hidden, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Search as IconSearch } from "@mui/icons-material";
import api from "../../services/api";
import PageHeader from "../common/PageHeader"
import React, { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setResults, setValue } from '../../redux/person/personSearchSlice';
import { PaperComponentDraggable } from "../common/PaperComponentDraggable";
import * as personaService from "../../services/personaService"
import DataGridBase from "../common/DataGridBase";

const PersonSearch = (props) => {
    const filters = useSelector((state) => state.personSearch.filters);
    const results = useSelector((state) => state.personSearch.results);
    const dispatch = useDispatch();
    const [selectItem, setSelectItem] = useState([]);
    const [cargando, setCargando] = useState(false);
    const dialogRef = useRef()
    const inputRef = useRef(null);

    useEffect(() => {
        if (!props.open) return;
        setTimeout(() => inputRef.current?.focus(), 250);
    }, [props.open]);

    const fetchResults = async () => {
        setCargando(true);
        const response = await personaService.getPersonaResumenBasicoViewByNumeroDocumentoYNombres(
            filters.numeroDocumento ?? "",
            filters.nombres ?? "",
            filters.empresa ?? "",)
        dispatch(setResults(response.data.data))
        setCargando(false);
    }

    useEffect(() => {
        dispatch(
            setValue({
                name: "empresa",
                value: props.empresa ?? ""
            })
        );
    }, [dispatch, props.open, props.empresa]);
    
    const columns = [
        { field: 'id', headerName: 'ID', width: 50 },
        { field: 'nombres', headerName: 'Nombres', width: 200, sortable: true },
        { field: 'tipoDocumento', headerName: 'Tip.Doc.', width: 100, sortable: false },
        { field: 'numeroDocumento', headerName: 'Num.Doc.', width: 100, sortable: false },
        { field: 'esEmpresa', headerName: 'Empresa', width: 30, sortable: false },
    ];

    return (
        <Dialog
            open={props.open}
            onClose={props.openClose}
            fullWidth={true}
            maxWidth={"md"}
            ref={dialogRef}
            PaperComponent={PaperComponentDraggable}
        >
            <DialogTitle
                id="draggable-dialog-title"
                style={{ cursor: "move" }}>
                <PageHeader title={"Buscar Persona"} />
            </DialogTitle>
            <DialogContent style={{ minHeight: "350px", maxHeight: "400px" }}>
                <Grid container item xs={12} sm={12} spacing={1} padding={1}>
                    <Grid item xs={6} sm={2}>
                        <TextField
                            name="numeroDocumento"
                            label="Num. Doc."
                            value={filters.numeroDocumento}
                            fullWidth
                            onChange={(event) => {
                                dispatch(setValue({name: "numeroDocumento", value: event.target.value}))
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                            inputRef={inputRef}
                        />
                    </Grid>
                    <Grid item xs={8} sm={3}>
                        <TextField
                            name="nombres"
                            label="Nombres"
                            value={filters.nombres}
                            fullWidth
                            onChange={(event) => {
                                dispatch(setValue({name: "nombres", value: event.target.value}))
                            }}
                            onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                    event.preventDefault();
                                    fetchResults();
                                }
                            }}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={6} sm={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Empresa</InputLabel>

                            <Select
                                label="Empresa"
                                value={filters.empresa ?? ""}
                                onChange={(event) => {
                                    dispatch(
                                        setValue({
                                            name: "empresa",
                                            value: event.target.value
                                        })
                                    );
                                }}
                            >
                                <MenuItem value="">
                                    Todos
                                </MenuItem>

                                <MenuItem value="S">
                                    Sí
                                </MenuItem>

                                <MenuItem value="N">
                                    No
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                        <Button variant="outlined" onClick={() => {
                            fetchResults()
                        }}>
                            {<Hidden smDown>Buscar</Hidden>}
                            <IconSearch />
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <DataGridBase
                            rows={results}
                            columns={columns}
                            loading={cargando}
                            showExport={false}
                            paginationTop={false}
                            pageSize={5}
                            pageSizeOptions={[5]}
                            onRowSelectionModelChange={(itm) => setSelectItem(itm)}
                            onRowDoubleClick={(params) => {
                                props.setSelection(params.row);
                                props.openClose();
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="primary" variant='contained' onClick={() => {
                    if (selectItem.length > 0) {
                        const selectItems = results.filter(item => item.id === selectItem[0]);
                        console.log(selectItems[0])
                        props.setSelection(selectItems[0]);
                        props.openClose()
                    }
                }}>Aceptar</Button>
                <Button variant='outlined' onClick={() => { props.openClose() }} >Cancelar</Button>
            </DialogActions>
        </Dialog>
    )
}

export default PersonSearch;
